let config = {
  "uLocalization": "/localizations/",
  "uData": "/data/",
  "sServerDateFormat": "YYYY-MM-DD HH:mm:ss",
  "sUIDateFormat": "MMM D, YYYY h:mA",
  "uServer": "http://somkidsgames.com/server",
  "uPosts": "/wp-json/wp/v2/posts?per_page=100",
  "uComments": "/wp-json/wp/v2/comments?per_page=10",
  "uPostComment": "/wp-json/wp/v2/comments",
};

export default config;



// WEBPACK FOOTER //
// ./src/config/server.js